import { LineClampProps } from './LineClamp.typed';
import { Container } from './LineClamp.styled';

const LineClamp = ({ children, forwardedAs, ...props }: LineClampProps) => {
  return (
    <Container as={forwardedAs} {...props}>
      {children}
    </Container>
  );
};

export { LineClamp };
